import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "..";
import { GET_ALL_CONTACT_FORMS, UPDATE_CONTACT_FORM_STATUS, DELETE_CONTACT_FORM } from "../Queries/corpMails";

export const getAllContactMailAsync = createAsyncThunk(
    "corpMails/getAllContactMailAsync",
    async(_,{rejectWithValue}) => {
        try {
            const {data} = await client.query({
                query: GET_ALL_CONTACT_FORMS,
                fetchPolicy: "no-cache",
            })
            return {
                status: data.getAllContactForms.status,
                message: data.getAllContactForms.message,
                response: data.getAllContactForms.response,
            }
        }
        catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const updateContactFormStatusAsync = createAsyncThunk(
    "corpMails/updateContactFormStatusAsync",
    async({id, status}, {rejectWithValue}) => {
        try {
            const {data} = await client.mutate({
                mutation: UPDATE_CONTACT_FORM_STATUS,
                variables: {id, status},
                fetchPolicy: "no-cache",
            })
            return {
                status: data.updateContactFormStatus.status,
                message: data.updateContactFormStatus.message,
                response: data.updateContactFormStatus.response,
            }
        }
        catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const deleteContactFormAsync = createAsyncThunk(
    "corpMails/deleteContactFormAsync",
    async({id}, {rejectWithValue}) => {
        try {
            const {data} = await client.mutate({
                mutation: DELETE_CONTACT_FORM,
                variables: {id},
                fetchPolicy: "no-cache",
            })
            return {
                status: data.deleteContactForm.status,
                message: data.deleteContactForm.message,
                response: data.deleteContactForm.response,
            }
        }
        catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const corpMailsSlice = createSlice({
    name:"corpMails",
    initialState:{
        contactMails: [],
        loading: false,
        error: null,
    },
    reducers:{},
    extraReducers: (builder) => {
        builder
        .addCase(getAllContactMailAsync.fulfilled, (state, action) => {
            state.contactMails = action.payload.response;
        })
        .addCase(updateContactFormStatusAsync.fulfilled, (state, action) => {
            const updatedForm = action.payload.response;
            state.contactMails = state.contactMails.map((form) =>
                form._id === updatedForm._id ? { ...form, status: updatedForm.status } : form
            );
        })
        .addCase(deleteContactFormAsync.fulfilled, (state, action) => {
            state.loading = false;
            const deletedFormId = action.payload.response._id;
            state.contactMails = state.contactMails.filter((form) => form._id !== deletedFormId);
        })
    }
        
});
export const {} = corpMailsSlice.actions;

export default corpMailsSlice.reducer;